module.exports = __webpack_public_path__ + "img/bg2.4c0ff5ce.jpg";